// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 620 ? "pdfjsWorker" : chunkId) + "." + {"359":"9c63827c","511":"b2b9cf9c","620":"efd48bf8","767":"41d68990"}[chunkId] + ".chunk.js";
};